import { MilitaryTechOutlined } from "@mui/icons-material";

const compensationResource = {
    title: "Compensation",
    singular: "Compensation",

    collectionField: "compensations",

    displayField: "EffectiveDate",
    icon: MilitaryTechOutlined,

    columns: [
        {
            field: "appointmentNumber",
            header: "Appointment Number",
            type: "text"
        },
        {
            field: "effectiveDate",
            header: "Effectivity Date",
            type: "date"
        },
        {
            field: "basicPay",
            header: "Basic Pay",
            type: "number"
        }
    ],

    fields: {
        appointmentNumber: {
            name: "appointmentNumber",
            label: "Appointment Number",
            type: "text",
            required: true
        },
        effectiveDate: {
            name: "effectiveDate",
            label: "Effectivity Date",
            type: "date",
            required: true
        },
        basicPay: {
            name: "basicPay",
            label: "Basic Pay",
            type: "number"
        },
        hasSSS: {
            name: "hasSSS",
            label: "SSS",
            type: "bool"
        },
        hasGsis: {
            name: "hasGsis",
            label: "GSIS",
            type: "bool"
        },
        hasPagIbig: {
            name: "hasPagIbig",
            label: "Pag-Ibig",
            type: "bool"
        },
        hasPhilHealth: {
            name: "hasPhilHealth",
            label: "PhilHealth",
            type: "bool"
        }
    }
};

export default compensationResource;
